<template>
    <div class="loader-box loader-box__large">
        <div class="loader-37"></div>
    </div>
</template>
<script>
export default {
    name: 'box-loading'
};
</script>
<style lang="scss">
.loader-box {
    &.loader-box__large {
        height: 350px;
    }
}
</style>
